
export interface Module {
  title: string
  body: string
}

export const modules: Module[] = [
  {
    title: 'Módulo 1',
    body: 'Fundamentos: qué flores elegir y cuándo cosecharlas',
  },
  {
    title: 'Módulo 2',
    body: '9 métodos de prensado, paso a paso',
  },
  {
    title: 'Módulo 3',
    body: 'Tiempos de secado y señales de que están listas',
  },
  {
    title: 'Módulo 4',
    body: 'Errores comunes y cómo solucionarlos',
  },
  {
    title: 'Módulo 5',
    body: 'Cuidado, conservación y almacenamiento',
  },
  {
    title: 'Módulo 6',
    body: '10 proyectos botánicos: cuadros, tarjetas y regalos personalizados',
  },
  {
    title: 'Módulo 7',
    body: 'Resina botánica: dijes, adornos y objetos decorativos',
  },
  {
    title: 'Módulo 8',
    body: 'Bordado botánico: piezas delicadas con flores reales',
  },
]
